import { render, staticRenderFns } from "./StrapiAlerteComponent.vue?vue&type=template&id=4fb775ae"
import script from "./StrapiAlerteComponent.vue?vue&type=script&lang=js"
export * from "./StrapiAlerteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports